import { EMPTY, MonoTypeOperatorFunction, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export function isPublicLinkUnavailable(error: any): boolean {
  return error?.status === 404;
}

export function isPublicLinkPasswordRejected(error: any): boolean {
  return error?.status === 403;
}

export function catchPublicLinkUnavailable<T>(onUnavailable: () => void): MonoTypeOperatorFunction<T> {
  return catchError(error => {
    if (!isPublicLinkUnavailable(error)) {
      return throwError(() => error);
    }
    onUnavailable();
    return EMPTY;
  });
}
